import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthentication } from '../../contexts/Authentication';

const Logout = () => {
  const auth = useAuthentication();
  const history = useHistory();

  useEffect(() => {
    auth.logout();
    history.push('/login');
  }, [auth, history]);

  return (
    <></>
  )
}

export default Logout;